export const setting= {
  name: "Moebius",
  production: true,
  c_domain: '.moebius.tur.ar',
  authApiUrl: 'https://fusionpax-api.fusionpax.com/api/',
  appUrl: 'https://moebius.tur.ar',  //cambiar por moebius.tur.ar
  appBookingBackoffice: 'https://booking-bo.moebius.tur.ar/',
  appBookingUrl: 'https://booking-app.moebius.tur.ar/',
  apiBookingUrl: 'https://booking-api.moebius.tur.ar/api/v1/',
  apiOctopusUrl: 'https://octopus-api.fusionpax.com/api',
  routeUploadFile: 'https://fusionpax-api.fusionpax.com/storage/',  // Temporal
  octopusUrl: 'https://octopus-api.fusionpax.com/api',
  apiStorageBooking: 'https://booking-api.moebius.tur.ar/storage/',
  appAbacoUrl: 'https://abaco-app.moebius.tur.ar/',  /// abaco
  appZocoUrl: 'https://zoco-app.moebius.tur.ar/',   /// zoco
  booking_api_user: "PRODAUTH1644",
  booking_api_key: "589099db7352718ed0ee84dc281eba69372cb27c985debb3c065a1d1663b69b0",
  ApiUser : "MOEV254135",
  ApiKey  : "7245M841O01EV25",
  fusionPaxTest: 'https://fusionpax-api-test.fusionpax.com/api/chat/messages',
  // Cloudflare Turnstile - captcha en login, resetPass, signup/agencies y signup/providers.
  // Switch temporal: dejar en false hasta tener la site key real Y que el backend
  // valide turnstileToken contra siteverify. En false, el widget no se muestra y
  // ning�n form exige token (no bloquea login/registro mientras tanto).
  turnstileEnabled: true,
  turnstileSiteKey: '0x4AAAAAAEc0p3d2iH-cEoHx',
  twoFactorEnabled: true,
  legacyAuthCookie: false,
  heroVariant: 'animated' as 'classic' | 'animated',
  app_names: {
        booking_backoffice: 'backoffice',
        zoco: 'zoco',
        booking: 'booking',
        abaco: 'abaco',
        chat: 'chat',
        octopus: 'octopus'
  },
  ActivatedGuard: true,
  key_local_storage: 'amE89mVkKihT^c%C&G5!wf2*4MX*dkkb6ZtbrsJAnASJmA9d5ddWjaCKLea$SWsvQB^L^q$M!qUm^LRK'
}
